import './bluefiretotal/style';
import FormStructure from './bluefiretotal/form_structure';

export default FormStructure;